const KEY = "ptg_enquiry_source";
const MAP = { instagram: "Instagram", ig: "Instagram", facebook: "Facebook", fb: "Facebook", whatsapp: "WhatsApp", wa: "WhatsApp" };

export const captureSource = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const raw = (p.get("src") || p.get("utm_source") || "").toLowerCase();
    let src = MAP[raw];
    if (!src) {
      const ref = document.referrer || "";
      if (/instagram\.com/i.test(ref)) src = "Instagram";
      else if (/facebook\.com|fb\.com/i.test(ref)) src = "Facebook";
      else if (/whatsapp/i.test(ref)) src = "WhatsApp";
    }
    if (src) sessionStorage.setItem(KEY, src);
  } catch { /* ignore */ }
};

export const getSource = () => {
  try { return sessionStorage.getItem(KEY) || "Website"; } catch { return "Website"; }
};
